<div class="rc-content">
  <div
    id="condition"
    class="sticky-sidebar"
    [class.filter-hidden]="!isFilterVisible"
  >
    <div class="shadow p-0">
      <div class="bs-canvas bs-canvas-anim bs-canvas-left">
        <!-- position-sticky-->
        <!-- Off-canvas sidebar markup, left/right or both. -->
        <app-search-filter
          (applySearchEvent)="onApplySearch($event)"
          (listComparisonDefEvent)="onListRegCompare()"
          (deleteComparisonDefEvent)="onListRegCompare()"
        >
        </app-search-filter>
      </div>
    </div>
  </div>

  <div
    id="result"
    class="main"
    [class.main-full-width]="!isFilterVisible"
    [class.main-hidden]="isFilterVisible"
  >
    @if (isLoading) {
      <div class="spinner-container">
        <mat-spinner></mat-spinner>
      </div>
    }
    <div class="container2">
      <div class="widget-toolbox" fxLayout="row" fxLayoutAlign="end center">
        @if (displayData && displayData.length > 0 && !isLoading) {
          <button
            mat-raised-button
            color="primary"
            (click)="onSaveSearchDefinition()"
          >
            Save Search Definition
          </button>
        }
        @if (noResultsMessage) {
          <span class="no-results-message">{{ noResultsMessage }}</span>
        }
        <span class="toolbar-spacer"></span>
        <button
          mat-icon-button
          class="filter-toggle-btn"
          [class.filter-toggle-visible]="!isFilterVisible"
          (click)="toggleFilter()"
          title="Show filters"
        >
          <mat-icon>search</mat-icon>
        </button>
      </div>
      <div class="table-containter">
        <table class="mat-table">
          <div class="y-scrollable">
            @for (item of displayData; track item; let i = $index) {
              <mat-card appearance="outline" class="mb-3">
                <mat-card-title
                  class="mat-row clickable"
                  [ngClass]="{
                    warn: item.collection === 0,
                    inprocess: item.collection === 2,
                  }"
                  (click)="
                    onShowProtocol(
                      item.productName,
                      item.topic,
                      item.rulebook,
                      item.section,
                      item.paraNum
                    )
                  "
                >
                  <span class="mat-cell">{{
                    (pageNumber - 1) * limit + i + 1
                  }}</span
                  >&nbsp;
                  <span
                    mattoolTip="Protocol Acronym"
                    class="mat-cell protocol-name"
                    >{{ item.productName }}</span
                  >&nbsp;> <span class="mat-cell">{{ item.topic }}</span
                  >&nbsp;> <span class="mat-cell">{{ item.rulebook }}</span
                  >&nbsp;
                  @if (item.section) {
                    > <span class="mat-cell">{{ item.section }}</span
                    >&nbsp;
                    @if (item.paraNum) {
                      > <span class="mat-cell">Para {{ item.paraNum }}</span>
                    }
                  }
                </mat-card-title>
                <mat-card-content>
                  <p
                    id="q{{ (pageNumber - 1) * limit + i + 1 }}"
                    class="onlyTwoLinesContent"
                    [innerHtml]="renderHtml(item.question, item.matchedTerms)"
                  ></p>
                  @if (
                    isExpanded("q" + ((pageNumber - 1) * limit + i + 1)) > 0
                  ) {
                    <button
                      mat-button
                      (click)="toggleClass($event, 'onlyTwoLinesContent')"
                      tooltip="Read more"
                      tooltipclass="tooltip2"
                      class="expand-collapse"
                    >
                      <mat-icon>{{
                        isExpanded("q" + ((pageNumber - 1) * limit + i + 1)) ===
                        1
                          ? "expand_more"
                          : "expand_less"
                      }}</mat-icon
                      >{{
                        isExpanded("q" + ((pageNumber - 1) * limit + i + 1)) ===
                        1
                          ? "Expand"
                          : "Collapse"
                      }}
                    </button>
                  }
                  <p
                    id="p{{ (pageNumber - 1) * limit + i + 1 }}"
                    class="onlyTwoLinesContent"
                    [innerHtml]="renderHtml(item.guidenote, item.matchedTerms)"
                  ></p>
                  @if (
                    isExpanded("p" + ((pageNumber - 1) * limit + i + 1)) > 0
                  ) {
                    <button
                      class="expand-collapse"
                      mat-button
                      (click)="toggleClass($event, 'onlyTwoLinesContent')"
                      tooltip="Read more"
                      tooltipclass="tooltip2"
                    >
                      <mat-icon>{{
                        isExpanded("p" + ((pageNumber - 1) * limit + i + 1)) ===
                        1
                          ? "expand_more"
                          : "expand_less"
                      }}</mat-icon
                      >{{
                        isExpanded("p" + ((pageNumber - 1) * limit + i + 1)) ===
                        1
                          ? "Expand"
                          : "Collapse"
                      }}
                    </button>
                  }
                </mat-card-content>
                <mat-card-footer class="card-footer">
                  <mat-chip-set aria-label="Chihuahua traits">
                    <mat-chip>{{
                      item.collection === 1
                        ? "Rulebook"
                        : item.collection === 2
                          ? "Applicability"
                          : "State Difference"
                    }}</mat-chip>
                    <mat-chip>{{ item.country }}</mat-chip>
                    <mat-chip>{{ item.jurisdiction }}</mat-chip>
                  </mat-chip-set>
                </mat-card-footer>
              </mat-card>
            }
          </div>
          <tfoot>
            <tr>
              <td colspan="11">
                <div class="pagination-container">
                  <div class="pagination-left">
                    @if (pageNumber > 1) {
                      <button
                        mat-button
                        class="button-action pagination-prev"
                        (click)="loadNext(false)"
                      >
                        <mat-icon class="pagination-arrow">arrow_back</mat-icon>
                        <span class="pagination-label">Previous</span>
                      </button>
                    }
                  </div>
                  @if (totalCount > 0) {
                    <div class="pagination-center">
                      @if (getTotalPages() > 0) {
                        <div class="page-numbers">
                          <!-- Always show page 1 if not in visible range -->
                          @if (pageNumber > 2) {
                            <span class="page-number" (click)="goToPage(1)"
                              >1</span
                            >
                            @if (pageNumber > 3) {
                              <span class="page-ellipsis">...</span>
                            }
                          }

                          @for (page of getVisiblePages(); track page) {
                            <span
                              class="page-number"
                              [class.current-page]="page === pageNumber"
                              (click)="goToPage(page)"
                              >{{ page }}</span
                            >
                          }

                          <!-- Always show last page if not in visible range -->
                          @if (pageNumber < getTotalPages() - 1) {
                            @if (pageNumber < getTotalPages() - 2) {
                              <span class="page-ellipsis">...</span>
                            }
                            <span
                              class="page-number"
                              (click)="goToPage(getTotalPages())"
                              >{{ getTotalPages() }}</span
                            >
                          }
                        </div>
                      }
                    </div>
                  }
                  <div class="pagination-right">
                    @if (!isLastPage() && totalCount > 0) {
                      <button
                        mat-button
                        class="button-action pagination-next"
                        (click)="loadNext(true)"
                      >
                        <span class="pagination-label">Next</span>
                        <mat-icon class="pagination-arrow"
                          >arrow_forward</mat-icon
                        >
                      </button>
                    }
                  </div>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>
